import { useQuery } from "@tanstack/react-query";
import { ExternalLink, PencilLine } from "lucide-react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { Panel } from "../admin/fields";

export const WebsitesPanel = () => {
  const { data } = useQuery({ queryKey: ["websites"], queryFn: () => api.get("/web").then((r) => r.data) });
  if (!data?.length) return null;
  return (
    <Panel title="Hotel websites" hint="Full hotel websites with the booking engine built in. Edit text and photos in the content editor.">
      <div className="divide-y divide-ink/5 rounded-xl border border-ink/10">
        {data.map((w) => (
          <div key={w.id} className="flex flex-wrap items-center gap-3 px-4 py-3 text-sm" data-testid={`website-row-${w.id}`}>
            <span className="min-w-0 flex-1 break-words">{w.name} <span className="font-mono text-xs text-ink/45">/{w.id} · booking site /s/{w.site_slug}</span></span>
            {w.website_url && <a href={w.website_url} target="_blank" rel="noreferrer" className="btn-ghost" data-testid={`website-view-${w.id}`}><ExternalLink className="h-4 w-4" />View</a>}
            <Link to={`/website-admin/${w.id}`} className="btn-outline !py-2" data-testid={`website-edit-${w.id}`}><PencilLine className="h-4 w-4" />Edit content</Link>
          </div>
        ))}
      </div>
    </Panel>
  );
};
